// extracted by mini-css-extract-plugin
export default {"root":"Switcher-module_root__wKjuW","option":"Switcher-module_option__eVKEx","active":"Switcher-module_active__YpaXH"};